import { withSuperJSONProps as _withSuperJSONProps, withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import Link from "next/link";
import React from "react";
import Image from "next/image";
import _ from "lodash";
import Meta from "../../../components/Meta";
import prisma from "../../../prisma/prisma";
import AreaQualifierView from "../../../components/loretta-lynn-tracker/area-qualifier-view";
import EntityMappingService from "../../../services/entity-mapping-service";
export const getServerSideProps = _withSuperJSONProps(async function getServerSideProps() {
  const year = 2024;
  const classes = await prisma.lorettasAreaQualifierClass.findMany({
    where: {
      year
    },
    distinct: ["name"],
    select: {
      name: true
    },
    orderBy: {
      name: "asc"
    }
  });
  const areasQuery = await prisma.lorettasAreaQualifiers.groupBy({
    where: {
      year
    },
    by: ["region"],
    _count: {
      region: true
    }
  });
  const areasMapped = areasQuery.map(x => {
    return {
      region: x.region,
      qualifiers: x._count.region
    };
  });
  const areas = _.chain(areasMapped).sortBy("region").value();
  return {
    props: {
      areas,
      classes
    }
    // revalidate: 50000
  };
}, []);
const Index = ({
  areas,
  classes
}) => {
  const year = 2024;
  return <>
      <Meta title="Loretta Lynn MX Tracker" data-sentry-element="Meta" data-sentry-source-file="index.jsx" />
      <section className="hero relative py-2 md:pt-10">
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 dark:hidden" data-sentry-element="picture" data-sentry-source-file="index.jsx">
          <figure className="h-[630px] w-full">
            <Image width={1519} height={712} className="w-full h-full object-cover" src="/images/gradient.jpg" alt="gradient" data-sentry-element="Image" data-sentry-source-file="index.jsx" />
          </figure>
        </picture>

        <div className="container">
          <div className="pt-24 pb-6 text-center">
            <h1 className="text-jacarta-700 font-display mb-6 text-5xl dark:text-white lg:text-6xl xl:text-7xl">
              {year} Loretta Lynn AMA Amateur National Championship Tracker
            </h1>
            <p className="dark:text-jacarta-200 mb-8 text-lg">
              Brought to you by GAME (Gregg Albertson Motocross Experience)
              training Facility located in Oaklahoma.
            </p>
            <div className="inline-flex space-x-8">
              <Link href="https://www.gamemotocoaching.com" className="bg-accent shadow-accent-volume hover:bg-accent-dark w-full rounded-full py-3 px-8 text-center font-semibold text-white transition-all" data-sentry-element="Link" data-sentry-source-file="index.jsx">
                Visit Game Moto's Website
              </Link>
            </div>
          </div>

          {!areas.length ? <>
              <h1 className="text-jacarta-700 mb-8 text-lg text-center py-20">
                {" "}
                Please bookmark this page. Once qualfiers begin, their results
                will be posted here.
              </h1>
            </> : <AreaQualifierView areas={areas} classes={classes} year={year} />}
        </div>
      </section>
    </>;
};
export default _withSuperJSONPage(Index);